import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { Nav, Navbar, NavbarBrand, NavbarText } from "reactstrap";
import Swal from "sweetalert2";
import { Userlogout } from "../../functions/CoreFunctions";
import { getAgencyLogo, getCustomerUrl } from "./CommonFunctions";
import logo from "../../images/logo.png";
import { useLocation } from "react-router";

export default function HeaderLogo({ userIndex, agencyUrl }) {
  const location = useLocation();
  const currentRoute = location.pathname;
  console.log(currentRoute.split("/")[1], "param");
  let history = useNavigate();
  let Logout = () => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to sign out",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Sign Out",
    }).then((result) => {
      if (result.isConfirmed) {
        Userlogout(history);
      }
    });
  };
 

  return (
    <>
      <Navbar color="white" className="usr-nav" expand="md">
        <Link to={`/customer/${agencyUrl || getCustomerUrl()}`}>
          <NavbarBrand>
            <img alt="" className="logo" src={logo} />
          </NavbarBrand>
        </Link>
        <Nav className="mr-auto" navbar></Nav>
        <NavbarBrand>
          <img className="logo" src={getAgencyLogo()} alt=""/>
        </NavbarBrand>
        {!userIndex && currentRoute.split("/")[1] !== "payment" ? (
          <NavbarText style={{ cursor: "pointer" }} onClick={() => Logout()}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="35"
              height="35"
              viewBox="0 0 35 35"
            >
              <g id="logout" transform="translate(-1410 -12)">
                <rect
                  id="Rectangle_1123"
                  data-name="Rectangle 1123"
                  width="35"
                  height="35"
                  rx="5"
                  transform="translate(1410 12)"
                  fill="#e4efff"
                />
                <path
                  id="exit"
                  d="M11.852,12.327v1.258A2.518,2.518,0,0,1,9.336,16.1H3.016A2.518,2.518,0,0,1,.5,13.584V2.516A2.518,2.518,0,0,1,3.016,0H9.336a2.518,2.518,0,0,1,2.516,2.516V3.773a.629.629,0,0,1-1.258,0V2.516A1.259,1.259,0,0,0,9.336,1.258H3.016A1.259,1.259,0,0,0,1.758,2.516V13.584a1.259,1.259,0,0,0,1.258,1.258H9.336a1.259,1.259,0,0,0,1.258-1.258V12.327a.629.629,0,0,1,1.258,0ZM16.14,6.97,14.731,5.561a.629.629,0,1,0-.889.889l1,1H7.292a.629.629,0,1,0,0,1.258h7.551l-1,1a.629.629,0,1,0,.889.889L16.14,9.193a1.574,1.574,0,0,0,0-2.224Zm0,0"
                  transform="translate(1418.5 21)"
                  fill="#1b3e6f"
                />
              </g>
            </svg>
          </NavbarText>
        ) : (
          <></>
        )}
      </Navbar>
    </>
  );
}
